module.exports = __webpack_public_path__ + "img/icon-plus.1ab1049c.svg";